import { FilteredAccount } from '@interfaces/models';

import { getAccountName } from './selected-accounts';

export const getShortAccountDisplayName = (account: FilteredAccount): string => {
  return !!account.nickname
    ? `${account.nickname} — ${account.accountNumber}`
    : account.formattedAccountName;
};

export const getAccountDisplayDescription = (account: FilteredAccount): string => {
  if (account.nickname) {
    const [name, accountString, _] = account.accountName.split(' — ');
    return `${name} — ${accountString}`;
  }
  return '';
};

export const getAccountDisplayNameWithNicknameAndLegalName = (
  account: FilteredAccount,
  additionalSigner: boolean,
): string => {
  if (additionalSigner) {
    return getAccountName(account, true);
  }
  return !!account.nickname
    ? `${account.nickname} — ${account.formattedAccountName}`
    : account.formattedAccountName;
};
